import { Dispatch, SetStateAction } from "react";
import { DisponibilityTab } from "../../schedulingsearch/components/DisponibilityTab";
import { NoDataWarning } from "../../../components/common";

interface IProps {
  slots: fhir5.BundleEntry<fhir5.Slot>[] | undefined;
  loading: boolean;
  location: fhir5.Location;
  setRefetchSlots: Dispatch<SetStateAction<boolean>>;
  scheduleCompleted?: any;
}

export function SlotsMobile({
  slots,
  loading,
  location,
  setRefetchSlots,
  scheduleCompleted,
}: IProps) {
  return (
    <>
      {slots ? (
        <DisponibilityTab
          slots={slots}
          loading={loading}
          location={location}
          setRefetchSlots={setRefetchSlots}
          scheduleCompleted={scheduleCompleted}
        />
      ) : (
        <NoDataWarning />
      )}
    </>
  );
}
